import { render, staticRenderFns } from "./StaffItem.vue?vue&type=template&id=5dfc4320&scoped=true&"
import script from "./StaffItem.vue?vue&type=script&lang=js&"
export * from "./StaffItem.vue?vue&type=script&lang=js&"
import style0 from "./StaffItem.vue?vue&type=style&index=0&id=5dfc4320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc4320",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dfc4320')) {
      api.createRecord('5dfc4320', component.options)
    } else {
      api.reload('5dfc4320', component.options)
    }
    module.hot.accept("./StaffItem.vue?vue&type=template&id=5dfc4320&scoped=true&", function () {
      api.rerender('5dfc4320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/StaffItem.vue"
export default component.exports